import type { ResumoLinha } from '../types';
import NumeroAnimado from '@/components/movimento/NumeroAnimado';
import { formatarCentavos, parseValorCentavos } from '../utils';

interface ResumoValoresProps {
  linhas: ResumoLinha[];
  quantidade: number;
}

// Os rótulos que vêm do banco nunca aparecem crus: "Taxas da operação" vira
// "Taxa de serviço" na tela. O preço continua vindo pronto do banco.
function rotuloDaLinha(texto: string): string {
  const t = texto.trim();
  if (/taxas?\s+da\s+opera/i.test(t)) return 'Taxa de serviço';
  return t;
}

export default function ResumoValores({ linhas, quantidade }: ResumoValoresProps) {
  // Ingresso gratuito: resumo_cobranca não devolve nenhuma linha.
  if (linhas.length === 0) {
    return (
      <div className="rounded-[16px] bg-background-50 p-4 shadow-pcard">
        <div className="flex items-center justify-between">
          <span className="text-[15px] text-foreground-950">Ingresso</span>
          <span className="text-[16px] font-bold text-foreground-950">Gratuito</span>
        </div>
      </div>
    );
  }

  const normais = linhas.filter((l) => !l.destaque);
  const total = linhas.find((l) => l.destaque);
  const totalCentavos = total ? parseValorCentavos(total.valor) * quantidade : 0;

  return (
    <div className="rounded-[16px] bg-background-50 p-4 shadow-pcard">
      <ul className="space-y-2">
        {normais.map((l, i) => {
          const ehIngresso = i === 0;
          const multiplicado = quantidade > 1 && ehIngresso;
          const rotulo = multiplicado
            ? `${quantidade} ingressos × ${l.valor}`
            : rotuloDaLinha(l.linha);

          return (
            <li
              key={`${l.linha}-${i}`}
              className="flex items-baseline justify-between gap-3 text-[14px]"
            >
              <span className="min-w-0 text-foreground-600">{rotulo}</span>
              {!multiplicado && (
                <span className="shrink-0 whitespace-nowrap font-semibold text-foreground-800">
                  {formatarCentavos(parseValorCentavos(l.valor) * quantidade)}
                </span>
              )}
            </li>
          );
        })}
      </ul>

      <div className="mt-3 flex items-baseline justify-between gap-3 border-t border-background-200 pt-3">
        <span className="text-[15px] font-extrabold text-foreground-950">Total</span>
        <NumeroAnimado
          valor={formatarCentavos(totalCentavos)}
          className="text-[18px] font-extrabold text-foreground-950"
        />
      </div>
    </div>
  );
}